export enum HelpTabNavItem {
  ContactUs = 'Contact Us',
  Documentation = 'Documentation',
  GettingStartedVideo = 'Getting Started Video',
  SafeguardsRuleReviewVideo = 'Safeguards Rule Review Video',
}
